// extracted by mini-css-extract-plugin
export default {"card":"common_card__vJrmd"};